import { ModalPriority, ModalTypes, useModalManager } from '@wwt/core/modals'

import { useSession } from './hooks/useSession'

export const restrict = (callback: () => void) => {
	if (!useSession.getState().token) {
		useModalManager
			.getState()
			.showModal(ModalTypes.Login, { onSuccess: callback }, ModalPriority.high)
		return
	}

	callback()
}
